class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    reloadSlickSlider();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

function reloadSlickSlider() {
  if (window.jQuery && typeof jQuery.fn.slick === 'function') {
    jQuery('.complemantory-product-list').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      infinite: false,
      autoplaySpeed: 2000,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#FEF3F1"/><g clip-path="url(#clip0_8433_4745)"><path d="M16.9617 11.6162C16.9617 12.4724 16.116 13.7508 15.2598 14.8239C14.159 16.2085 12.8436 17.4166 11.3356 18.3385C10.2048 19.0297 8.83403 19.6931 7.73096 19.6931M7.73096 19.6931C8.83403 19.6931 10.206 20.3566 11.3356 21.0477C12.8436 21.9708 14.159 23.1789 15.2598 24.5612C16.116 25.6354 16.9617 26.9162 16.9617 27.7701M7.73096 19.6931H29.0771" stroke="#FF4B99" stroke-width="1.5"/></g><defs><clipPath id="clip0_8433_4745"><rect width="21.9231" height="20.7692" fill="white" transform="translate(7.73096 9.30908)"/></clipPath></defs></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="18" cy="18" r="18" fill="#FEF3F1"/><g clip-path="url(#clip0_8433_4741)"><path d="M18.4616 10.2319C18.4616 11.0881 19.3074 12.3665 20.1635 13.4396C21.2643 14.8242 22.5797 16.0323 24.0878 16.9542C25.2185 17.6454 26.5893 18.3089 27.6924 18.3089M27.6924 18.3089C26.5893 18.3089 25.2174 18.9723 24.0878 19.6635C22.5797 20.5865 21.2643 21.7946 20.1635 23.1769C19.3074 24.2512 18.4616 25.5319 18.4616 26.3858M27.6924 18.3089H6.34623" stroke="#FF4B99" stroke-width="1.5"/></g><defs><clipPath id="clip0_8433_4741"><rect width="21.9231" height="20.7692" fill="white" transform="matrix(-1 0 0 1 27.6924 7.9248)"/></clipPath></defs></svg></button>'
    });
  } else {
    console.error('jQuery or Slick is not loaded.');
  }
}

// Optional: Call it on DOMContentLoaded
document.addEventListener('DOMContentLoaded', reloadSlickSlider);

